import { Quote, Star } from "lucide-react";

const REVIEWS = [
  {
    quote:
      "Outstanding customer service, with prompt responses. Always available to answer questions—even on weekends. Highly recommended for anyone seeking expert advice and support for seamless, end-to-end loan approval.",
    name: "Naga Pandalaneni",
    source: "Google Review",
  },
  {
    quote:
      "This is the second time Nelson helped me a lot for my refinance and home loan. He is extremely knowledgeable, transparent, helpful and happy to answer any question at any time. He always gives enough time to explain all the options available and makes everything easy to decide. Highly recommended to get into property investment market…. Thanks.",
    name: "Bharat Gadakh",
    source: "Google Review",
  },
  {
    quote:
      "Connecting with Nelson was the game-changer for us, as he made the entire process seamless. We were constantly kept updated with the progress of our application without having to follow up. Nelson is very knowledgeable and always suggests the best option.",
    name: "Neeraj Shukla",
    source: "Google Review",
  },
  {
    quote:
      "I recently refinanced my home loan with Nelson, and I couldn't be happier with the experience. From start to finish, Nelson was incredibly prompt, always reachable, and quick to respond to every question I had. His knowledge and guidance made the entire refinancing process smooth and stress-free. He secured me a better interest rate along with a cashback offer, which was a fantastic outcome. Even though I've known Nelson personally, he handled everything professionally and kept me informed throughout the process. I highly recommend Nelson to anyone looking for a knowledgeable, reliable, and dedicated mortgage broker.",
    name: "Nithi Kalisamy",
    source: "Google Review",
  },
  {
    quote:
      "I had a great experience working with Nelson. He was extremely helpful, professional, and supportive throughout the entire home loan process. Nelson took the time to understand my requirements, explained everything clearly, and worked hard to secure a very competitive interest rate that suited my situation. He made what could have been a stressful process feel simple and straightforward. I really appreciate his communication, attention to detail, and commitment to getting the best possible outcome for me. I would definitely recommend Nelson to anyone looking for a reliable and trustworthy mortgage broker. Thank you, Nelson, for all your help and for making the loan process so smooth! Highly recommended!",
    name: "Ragulnath Krishnamurthy",
    source: "Google Review",
  },
  {
    quote:
      "I recently settled my first SMSF property financed through Nelson. He is very knowledgeable and know what he is doing. Always quick to respond which is key in the complicated SMSF process. I highly recommend Nelson for your finance requirements.",
    name: "Naveen Challagulla",
    source: "Google Review",
  },
  {
    quote:
      "Highly Recommended – Excellent Support Throughout My Home-Buying Journey! I had a wonderful experience with Nelson Saini, who supported me throughout my entire home-buying journey. From helping me find the right home to patiently answering all my finance-related questions, Nelson was always approachable, knowledgeable, and supportive. Buying a home can be a complicated and stressful process, but Nelson made the entire experience much smoother by guiding me through every step, providing clear advice, and ensuring I felt confident in making important decisions. His professionalism, dedication, and willingness to help went above and beyond my expectations. I truly appreciate his end-to-end support, responsiveness, and genuine commitment to helping me achieve my goal of owning a home. I would highly recommend Nelson Saini to anyone looking to buy a property and wanting reliable guidance and support throughout the process. Thank you, Nelson, for making my home-buying journey such a positive and memorable experience! 🏡🙏",
    name: "Ankit Saini",
    source: "Google Review",
  },
];

export const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="py-24 md:py-32 bg-brand-sand"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 mb-14 items-end">
          <div className="lg:col-span-7">
            <div className="label-eyebrow text-brand-terracotta mb-5">
              Client stories
            </div>
            <h2 className="font-display text-4xl sm:text-5xl tracking-tight font-medium text-brand-ink">
              Real Australians. Real outcomes.
            </h2>
          </div>
          <div className="lg:col-span-4 lg:col-start-9 flex items-center gap-2 lg:justify-end">
            <div className="flex">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star
                  key={i}
                  className="h-4 w-4 fill-brand-terracotta text-brand-terracotta"
                  strokeWidth={1.6}
                />
              ))}
            </div>
            <span className="text-sm text-brand-ink/65">From our Google reviews</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {REVIEWS.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="rounded-2xl border border-border bg-brand-cream p-6 lg:p-8 flex flex-col transition-all duration-300 hover:-translate-y-1 hover:shadow-md"
            >
              <div className="flex items-center justify-between">
                <Quote className="h-6 w-6 text-brand-terracotta" strokeWidth={1.6} />
                <div className="flex">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star
                      key={s}
                      className="h-3.5 w-3.5 fill-brand-terracotta text-brand-terracotta"
                      strokeWidth={1.6}
                    />
                  ))}
                </div>
              </div>
              <blockquote className="mt-5 text-base text-brand-ink/85 leading-relaxed">
                &ldquo;{t.quote}&rdquo;
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-border flex items-center justify-between">
                <div>
                  <div className="font-display text-base text-brand-ink">{t.name}</div>
                </div>
                <div className="text-[11px] uppercase tracking-widest text-brand-ink/50">
                  {t.source}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};
